// extracted by mini-css-extract-plugin
export default {"list":"E","link":"F","isDark":"G","icon":"H","blinking":"I"};